import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useMe } from "@/hooks/use-me";

export const Route = createFileRoute("/_auth/media")({
  component: MediaLayout,
});

function MediaLayout() {
  const { data: me } = useMe();
  const isAdmin = me?.role === "owner" || me?.role === "admin";
  return (
    <div className="px-6 py-6 max-w-[1480px] mx-auto">
      <header className="mb-5">
        <p className="text-xs text-ink-500 mb-1">HOLACLIENTE — Agencia de Medios</p>
        <h1 className="text-2xl font-bold text-ink-900 dark:text-white">Medios tradicionales</h1>
        <p className="text-sm text-ink-500 mt-1">
          Trazabilidad de campañas en radio, televisión, prensa escrita y medios digitales.
        </p>
      </header>

      <nav className="flex gap-1 mb-6 border-b border-ink-200 overflow-x-auto">
        <TabLink to="/media">Dashboard</TabLink>
        <TabLink to="/media/campaigns">Campañas</TabLink>
        <TabLink to="/media/ads">Avisos</TabLink>
        <TabLink to="/media/outlets">Medios</TabLink>
        <TabLink to="/media/ad-types">Tipos de aviso</TabLink>
        <TabLink to="/media/ad-categories">Categorías</TabLink>
        <TabLink to="/media/reports">Reportes</TabLink>
        {isAdmin && <TabLink to="/media/budgets">Presupuestos</TabLink>}
      </nav>

      <Outlet />
    </div>
  );
}

function TabLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      activeOptions={{ exact: to === "/media" }}
      className="px-4 py-2 text-sm font-medium text-ink-600 hover:text-ink-900 border-b-2 border-transparent transition-colors data-[status=active]:text-brand-600 data-[status=active]:border-brand-600 [&.active]:text-brand-600 [&.active]:border-brand-600"
    >
      {children}
    </Link>
  );
}
